<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  [class]="
    isShowNumbersImportFromXlsx || isShowNumbersDeleteFromXlsx ? 'd-none' : ''
  "
  (onSelectAll)="onSelectAll($event)"
>
  <!--------------------------------------- Table Content --------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="!tw-px-4 !tw-py-2 tw-text-center">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- mobile12 -->
        <td>
          <td-value copyToClipboard [value]="item?.mobile"></td-value>
        </td>

        <!-- stateId -->
        <td>
          <td-value [value]="item?.stateName"></td-value>
        </td>

        <!-- cityId -->
        <td>
          <td-value copyToClipboard [value]="item?.cityName"></td-value>
        </td>

        <!-- genderType -->
        <td>
          <span>{{
            item?.genderType | enumToText : GenderTypeEnumValues
          }}</span>
        </td>

        <!-- guildId -->
        <td>
          <td-value copyToClipboard [value]="item?.guildName"></td-value>
        </td>

        <!-- subGuildId -->
        <td>
          <td-value copyToClipboard [value]="item?.subGuildName"></td-value>
        </td>

        <!-- mobileOperator -->
        <td>
          <div
            class="tw-flex-center"
            [matTooltip]="
              item?.mobileOperator | enumToText : SmsAggregatorEnumValues
            "
            [matTooltipDisabled]="tooltipDisabled(item?.mobileOperator)"
            [mobileOperatorImg]="{
              mobileOperator: item?.mobileOperator,
              mobileOperatorEnumValue:
                item?.mobileOperator | enumToText : SmsAggregatorEnumValues
            }"
          ></div>
        </td>

        <!-- simType -->
        <td>
          <span [simType]="item?.simType">{{
            item?.simType | enumToText : SimTypeEnumValues
          }}</span>
        </td>

        <!-- zipCode10 -->
        <td>
          <td-value [value]="item?.zipCode"></td-value>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-bulk-number-information-form
    page-form
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-bulk-number-information-form>
</ng-container>

<!--delete numbers from xlsx file-->
<app-bulk-numbers-delete-from-xlsx
  *ngIf="isShowNumbersDeleteFromXlsx"
  (closeFormPage)="getDeleteNumbersFromXlsxResponse()"
>
</app-bulk-numbers-delete-from-xlsx>

<!-------------------------------------- help -------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
